<script setup lang="ts">
import { defineProps, ref } from 'vue'
import { ReferralCode } from '../../../../typings'
import BaseInputClipboard from '../../../base/BaseInputClipboard.vue'
import FacebookShareIcon from '../../../../asset/FacebookShareIcon.vue'
import TwitterShareIcon from '../../../../asset/TwitterShareIcon.vue'
import LinkedInShareIcon from '../../../../asset/LinkedInShareIcon.vue'
import WhatsappShareIcon from '../../../../asset/WhatsappShareIcon.vue'

const props = defineProps<{ referralCode: ReferralCode }>()

const referralUrl = ref(getReferralUrl(props.referralCode.code))

function getReferralUrl(code): string {
    return window.location.origin + '?referral=' + code
}
</script>

<template>
    <div>
        <div class="grid grid-cols-3 gap-x-4 gap-y-8 px-4 py-5 sm:grid-cols-3 sm:px-6">
            <div class="sm:col-span-3">
                <BaseInputClipboard :value="referralUrl" :label="$t('referral_program.your_referral_link')" />
            </div>
        </div>
        <div class="mt-10 flex items-center justify-center space-x-10">
            <ShareNetwork
                network="facebook"
                :url="referralUrl"
                :title="$t('referral_program.referral_link_social_media_sharing')">
                <FacebookShareIcon class="w-10 hover:opacity-80" />
            </ShareNetwork>
            <ShareNetwork
                network="twitter"
                :url="referralUrl"
                :title="$t('referral_program.referral_link_social_media_sharing')">
                <TwitterShareIcon class="w-10 hover:opacity-80" />
            </ShareNetwork>
            <ShareNetwork
                network="linkedin"
                :url="referralUrl"
                :title="$t('referral_program.referral_link_social_media_sharing')">
                <LinkedInShareIcon class="w-10 hover:opacity-80" />
            </ShareNetwork>
            <ShareNetwork
                network="whatsapp"
                :url="referralUrl"
                :title="$t('referral_program.referral_link_social_media_sharing')">
                <WhatsappShareIcon class="w-10 hover:opacity-80" />
            </ShareNetwork>
        </div>
    </div>
</template>
